import {BitrixVue} from 'ui.vue3';
import { FooterTrustHost } from './footer-trust-host';
import { NewsletterHost } from '../newsletter/newsletter-host';
import { NewsletterDialogHost } from '../newsletter/newsletter-dialog-host';
import { resolveComponent } from '../app/lazy';
import { vplSiteStore } from '../../store/vplstore';
import { mapState } from 'ui.vue3.pinia';

import { PhoneFooter } from '../links/phonefooter';
import { PhoneFooterTwo } from '../links/phonefootertwo';
import { EmailFooter } from '../links/emailfooter';
import { EmailFooterTwo } from '../links/emailfootertwo';
import { MessengerLinks } from '../messengers/messenger-links';

import { FavoriteMenuFooter } from '../menu/favoritemenufooter';
import { CompareMenuFooter } from '../menu/comparemenufooter';
import { BasketFooter } from '../basket/basketfooter';

import { FooterMenu1 } from '../menu/footermenu1';
import { FooterMenu2 } from '../menu/footermenu2';
import { FooterMenu3 } from '../menu/footermenu3';

import { PanelPersonalMenu } from '../menu/panelpersonalmenu';

import { CatalogViewed } from '../catalog.products.viewed/catalogviewed';

import { ContactUsModal } from '../forms/contactusmodal';
import { CallbackModal } from '../forms/callbackmodal';

import { FastView } from '../catalog.element/fastview';

import { number_format } from '../../tools/functions';

import { Auth } from '../auth/auth'

import { clearSearch, closeHeaderCatalog, clearHeaderMenuDropdown, showCatalogMenu } from '../../tools/functions';
import { openMobileMenu, preloadMobileMenu, mobileMenuState } from '../mobile-menu/mobile-menu-state';


export const Footer = {
    components: {
      FooterTrustHost,
      NewsletterHost,
      NewsletterDialogHost,
      CompanyReviews: resolveComponent('CompanyReviews'),
      PhoneFooter,
      PhoneFooterTwo,
      EmailFooter,
      EmailFooterTwo,
      MessengerLinks,
      FavoriteMenuFooter,
      CompareMenuFooter,
      BasketFooter,
      FooterMenu1,
      FooterMenu2,
      FooterMenu3,
      PanelPersonalMenu,
      Auth,
      CatalogViewed,
      FastView,
      ContactUsModal,
      CallbackModal
    },
    computed: {
        ...mapState(vplSiteStore, ['url', 'struct', 'rekey', 'templateData', 'SITE_TEMPLATE_PATH', 'favorite', 'compare' , 'basket']),
        showCompanyReviews() {
            return this.isMainPage() || Object.values(this.struct || {}).some(block =>
                block.componentData?.VUE_COMPONENT === 'CatalogElement'
                && Number(block.componentData?.ITEM?.ID) > 0
            );
        },
        mobileMenuPending() { return mobileMenuState.pending; }
    },
    methods: {
      number_format: number_format,

      isMainPage(){
        if(this.url !== '/'){
          return false;
        }else{
          return true;
        }
      },
      toTop(){
        $('html').animate({
          scrollTop: 0
        }, 200);
      },
      closeOverlay(){
        clearSearch();
        closeHeaderCatalog();
        clearHeaderMenuDropdown();
      },
      menuPreload() {
        if (window.innerWidth < 991) {
          preloadMobileMenu().catch(() => { /* повторится при открытии */ });
        }
      },
      openCatalogMenu(event){
        clearSearch();
        closeHeaderCatalog();
        openMobileMenu('catalog', event.currentTarget);
      }
    },
    mounted(){
      $('.js-overlay').click(function () {
        clearSearch();
        closeHeaderCatalog();
      });

      function fixedBtn() {
        if ($(window).scrollTop() > 500) {
          $('.js-top').addClass("is-show");
        } else {
          $('.js-top').removeClass("is-show");
        }

      };

      fixedBtn();

      window.addEventListener("scroll", function() {
        fixedBtn();
      }, {passive: true});
    },
    template: `

<CatalogViewed />
<!-- SAIT-146, SAIT-160: на главной и в карточке отзывы после просмотренных товаров, перед футером. -->
<CompanyReviews v-if="showCompanyReviews" :key="rekey" />
<!-- <MessengerLinks /> -->

<div class="mob-contacts js-mob-contacts">
  <div class="container">
    <div class="mob-contacts__wp">
      <div class="mob-contacts__heading">
        <div class="mob-contacts__title">Связаться с нами</div>
        <a href="#" class="mob-contacts__close js-mob-contacts-close">
          <svg class="icon icon-close"><use xlink:href="#icon-close"></use></svg>
        </a>
      </div>
      <div class="mob-contacts__content">
        <div class="mob-contacts__content-top">
          <PhoneFooter />
          <EmailFooter />
        </div>
        <a href="#" data-toggle="modal" data-target="#callback" class="mob-contacts__social">
          <svg class="ico ico-soc1" width="17" height="16" aria-hidden="true"><use xlink:href="#ico-soc1"></use></svg>
          Заказать звонок
        </a>
        <MessengerLinks variant="contacts" />
      </div>
    </div>
  </div>
</div>

<div class="panel js-panel is-active">
  <div class="container">
    <div class="panel__wp">
      <a href="/" class="panel__item">
          <span class="panel__item-ico">
              <svg class="icon icon-home"><use xlink:href="#icon-home"></use></svg>
          </span>
          <span>Главная</span>
      </a>
      <a href="/catalog/" data-skip="y" class="panel__item" aria-label="Открыть каталог"
         aria-haspopup="dialog" :aria-busy="mobileMenuPending"
         :class="{ 'is-pending': mobileMenuPending }" @click.prevent="openCatalogMenu($event)"
         @touchstart.passive="menuPreload()" @pointerenter="menuPreload()">
          <span class="panel__item-ico">
              <svg class="icon icon-catalog"><use xlink:href="#icon-catalog"></use></svg>
          </span>
          <span>{{ mobileMenuPending ? 'Загрузка…' : 'Каталог' }}</span>
      </a>
      <BasketFooter />
      <FavoriteMenuFooter />
      <CompareMenuFooter />
      <PanelPersonalMenu />
    </div>
  </div>
</div>

<footer class="footer">
  <div class="footer__main lazy-bg">
    <div class="container">
      <a href="#" class="to-top js-to-top" @click.prevent="toTop()">
        Наверх
        <svg class="icon footer__to-top-icon" width="10" height="7" aria-hidden="true"><use xlink:href="#footer-arrow-up"></use></svg>
      </a>
      <NewsletterHost source="footer" variant="footer" />
      <div class="footer__main-top">
        <div class="footer__main-contacts">
          <div class="contacts-socials">
            <PhoneFooterTwo />
            <EmailFooterTwo />
          </div>
          <a href="#" data-toggle="modal" data-target="#contactUs" class="btn btn--green">Связаться с нами</a>
          <div v-if="templateData.menuSoc && templateData.menuSoc.length" class="footer__socials">
            <a v-for="mess in templateData.menuSoc" :key="mess.ICON" :href="mess.LINK" :class="mess.ICON" class="footer__social-link" target="_blank" rel="nofollow">
              <svg :class="'icon ' + mess.ICON" width="24" height="24" aria-hidden="true"><use :xlink:href="['icon-vk', 'icon-dzen', 'icon-tg'].includes(mess.ICON) ? '#footer-' + mess.ICON : '#' + mess.ICON"></use></svg>
              <span>{{ mess.NAME }}</span>
            </a>
          </div>
        </div>
        <div class="footer__main-menus">
          <div class="footer__main-menus-main">
            <ul>
              <FooterMenu1 />
            </ul>
          </div>
          <div class="footer__main-menus-wp">
            <ul>
              <li>
                <span class="footer__main-menu-title">Компания</span>
              </li>
              <FooterMenu2 />
            </ul>
            <ul>
              <li>
                <span class="footer__main-menu-title">Покупателям</span>
              </li>
              <FooterMenu3 />
            </ul>
          </div>
        </div>
        <div class="footer__main-rightside">

          <div v-if="this.templateData.currency" class="footer__currencies">
              <div class="footer__currencies-top">
                <div class="footer__currencies-item">
                  <span>$</span>
                  {{ number_format(this.templateData.currency.USD.RATE, 2, ',') }}
                </div>
                <div class="footer__currencies-item">
                  <span>€</span>
                  {{ number_format(this.templateData.currency.EUR.RATE, 2, ',') }}
                </div>
              </div>
              <div v-if="this.templateData.currencyDate" class="footer__currencies-bottom">
                {{ this.templateData.currencyDate }}
              </div>
          </div>

          <div class="footer__requisites">
            <div v-if="this.templateData.companyName" class="footer__requisites-name">
              {{ this.templateData.companyName }}
            </div>
            <div v-if="this.templateData.address" class="footer__requisites-address" v-html="this.templateData.address">
            </div>
            <div class="footer__requisites-numbs">
              <span v-if="this.templateData.inn">ИНН:</span> {{ this.templateData.inn }} <br>
              <span v-if="this.templateData.ogrn">ОГРН:</span> {{ this.templateData.ogrn }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="footer__info">
    <div class="container ">
      <div class="footer__info-wp">
        <span v-if="this.templateData && this.templateData.copy" class="footer__info-copy">
          {{ this.templateData.copy }}
        </span>
        <a href="/sitemap/" class="footer__info-link">
          Карта сайта
        </a>
        <a href="/politika-konfidentsialnosti/" class="footer__info-link">
          Политика конфиденциальности
        </a>
        <FooterTrustHost :template-path="SITE_TEMPLATE_PATH" />
      </div>
    </div>
  </div>
</footer>
<NewsletterDialogHost />
<a href="#" class="btn-top js-to-top js-top" @click.prevent="toTop()">
  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="22" viewBox="0 0 17 22" fill="none">
    <path d="M8.06641 21.1309L8.06641 1.13086" stroke="#2C291F" stroke-width="1.6"/>
    <path d="M0.566406 8.63086L8.06641 1.13086L15.5664 8.63086" stroke="#2C291F" stroke-width="1.6"/>
  </svg>
</a>
<div class="modal fade modal-fastbuy hide" id="fastbuy"  tabindex="-1" style="display: none;" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <div class="modal-title">Быстрая покупка</div>
          <button aria-label="Закрыть" type="button" class="close" data-dismiss="modal">
              <span aria-hidden="true">
                <svg class="icon icon-close"><use xlink:href="#icon-close"></use></svg>
              </span>
          </button>
      </div>
      <FastView />
    </div>
  </div>
</div>

<ContactUsModal />

<CallbackModal />

<div class="modal fade modal-success hide" id="success"  tabindex="-1" style="display: none;" aria-hidden="true">
  <div class="modal-dialog">
      <div class="modal-content">
          <div class="modal-header">
              <button aria-label="Закрыть" type="button" class="close" data-dismiss="modal">
                  <span aria-hidden="true">
                    <svg class="icon icon-close"><use xlink:href="#icon-close"></use></svg>
                  </span>
              </button>
          </div>
          <div class="modal-body">
            <div class="modal-title">Ваше сообщение
               <br>
               отправлено</div>

            <a href="#" data-dismiss="modal" aria-label="Close" class="btn btn--green">
              Закрыть
            </a>
          </div>
      </div>
  </div>
</div>

<div class="modal fade modal-success hide" id="success-oneclick-order"  tabindex="-1" style="display: none;" aria-hidden="true">
  <div class="modal-dialog">
      <div class="modal-content">
          <div class="modal-header">
              <button aria-label="Закрыть" type="button" class="close" data-dismiss="modal">
                  <span aria-hidden="true">
                    <svg class="icon icon-close"><use xlink:href="#icon-close"></use></svg>
                  </span>
              </button>
          </div>
          <div class="modal-body">
            <div class="modal-title"> Спасибо за Ваш заказ!
               <br>
               Менеджер свяжется с вами в течение дня.</div>

            <a href="#" data-dismiss="modal" aria-label="Close" class="btn btn--green">
              Закрыть
            </a>
          </div>
      </div>
  </div>
</div>

<Auth />

<div class="modal fade modal-success modal-success-reg hide" id="success-reg"  tabindex="-1" style="display: none;" aria-hidden="true">
  <div class="modal-dialog">
      <div class="modal-content">
          <div class="modal-header">
              <button aria-label="Закрыть" type="button" class="close" data-dismiss="modal">
                  <span aria-hidden="true">
                    <svg class="icon icon-close"><use xlink:href="#icon-close"></use></svg>
                  </span>
              </button>
          </div>
          <div class="modal-body">
            <div class="modal-title">Вы успешно зарегистрированы на сайте.</div>
            <div class="modal-subtitle">
              Удачных покупок!
            </div>

            <a href="#" data-dismiss="modal" aria-label="Close" class="btn btn--green">
              Закрыть
            </a>
          </div>
      </div>
  </div>
</div>

<div class="modal fade modal-success modal-success-reg hide" id="success-auth"  tabindex="-1" style="display: none;" aria-hidden="true">
  <div class="modal-dialog">
      <div class="modal-content">
          <div class="modal-header">
              <button aria-label="Закрыть" type="button" class="close" data-dismiss="modal">
                  <span aria-hidden="true">
                    <svg class="icon icon-close"><use xlink:href="#icon-close"></use></svg>
                  </span>
              </button>
          </div>
          <div class="modal-body">
            <div class="modal-title">Вы успешно вошли на сайт.</div>
            <div class="modal-subtitle">
              Удачных покупок!
            </div>

            <a href="#" data-dismiss="modal" aria-label="Close" class="btn btn--green">
              Закрыть
            </a>
          </div>
      </div>
  </div>
</div>


<div class="modal fade modal-success modal-success-reg hide" id="dialog"  tabindex="-1" style="display: none;" aria-hidden="true">
  <div class="modal-dialog">
      <div class="modal-content">
          <div class="modal-header">
              <button aria-label="Закрыть" type="button" class="close" data-dismiss="modal">
                  <span aria-hidden="true">
                    <svg class="icon icon-close"><use xlink:href="#icon-close"></use></svg>
                  </span>
              </button>
          </div>
          <div class="modal-body">
            <div class="modal-title js-text" ></div>


            <a href="#" data-dismiss="modal" aria-label="Close" class="btn btn--green">
              Закрыть
            </a>
          </div>
      </div>
  </div>
</div>

<div class="overlay js-overlay"></div>
    `
}
